import action from 'app/lib/action';
import {DELETE_VISIT} from '../constants/actionTypes';

export default {
    request : (trac) => action(DELETE_VISIT.REQUEST)({trac}),
    success : (trac) => action(DELETE_VISIT.SUCCESS)({trac}),
    error   : (error) => action(DELETE_VISIT.ERROR)({error})
};